const actions = {
    SHOEBOX_READ_ITEMS_REQUEST: 'SHOEBOX_READ_ITEMS_REQUEST',
    SHOEBOX_READ_ITEMS_SUCCESS: 'SHOEBOX_READ_ITEMS_SUCCESS',
    SHOEBOX_READ_ITEMS_ERROR: 'SHOEBOX_READ_ITEMS_ERROR',
    SHOEBOX_READ_ITEM_REQUEST: 'SHOEBOX_READ_ITEM_REQUEST',
    SHOEBOX_READ_ITEM_SUCCESS: 'SHOEBOX_READ_ITEM_SUCCESS',
    SHOEBOX_READ_ITEM_ERROR: 'SHOEBOX_READ_ITEM_ERROR',
    SHOEBOX_DELETE_ITEM_REQUEST: 'SHOEBOX_DELETE_ITEM_REQUEST',
    SHOEBOX_DELETE_ITEM_SUCCESS: 'SHOEBOX_DELETE_ITEM_SUCCESS',
    SHOEBOX_DELETE_ITEM_ERROR: 'SHOEBOX_DELETE_ITEM_ERROR',
    SHOEBOX_ADD_LIST_ITEM: 'SHOEBOX_ADD_LIST_ITEM',
    SHOEBOX_SET_LIST_ITEM: 'SHOEBOX_SET_LIST_ITEM',
    SHOEBOX_REMOVE_LIST_ITEM: 'SHOEBOX_REMOVE_LIST_ITEM',
    SHOEBOX_SET_ITEM: 'SHOEBOX_SET_ITEM',
    SHOEBOX_SET_ACTIVE_ITEM_ID: 'SHOEBOX_SET_ACTIVE_ITEM_ID',
    SHOEBOX_SET_ITEM_STATUS: 'SHOEBOX_SET_ITEM_STATUS',
    SHOEBOX_RESET: 'SHOEBOX_RESET',

    readItems: request => ({
        type: actions.SHOEBOX_READ_ITEMS_REQUEST,
        request,
    }),
    readItem: id => ({
        type: actions.SHOEBOX_READ_ITEM_REQUEST,
        id,
    }),
    deleteItem: ids => ({
        type: actions.SHOEBOX_DELETE_ITEM_REQUEST,
        ids,
    }),
    addListItem: item => ({
        type: actions.SHOEBOX_ADD_LIST_ITEM,
        item,
    }),
    setListItem: item => ({
        type: actions.SHOEBOX_SET_LIST_ITEM,
        item,
    }),
    removeListItem: id => ({
        type: actions.SHOEBOX_REMOVE_LIST_ITEM,
        id,
    }),
    setItem: item => ({
        type: actions.SHOEBOX_SET_ITEM,
        item,
    }),
    setActiveItemId: id => ({
        type: actions.SHOEBOX_SET_ACTIVE_ITEM_ID,
        id,
    }),
    setItemStatus: status => ({
        type: actions.SHOEBOX_SET_ITEM_STATUS,
        status,
    }),
    reset: () => ({
        type: actions.SHOEBOX_RESET,
    }),
};
export default actions;
